import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { UiModelingState } from './ui-modeling.model';
import { UiModelingStore } from './ui-modeling.store';

@Injectable({ providedIn: 'root' })
export class UiModelingStoreQuery extends QueryEntity<UiModelingState> {
  constructor(protected readonly store: UiModelingStore) {
    super(store);
  }
}
